<div class="outerContainer">
    <div class="card">
        <div class="card-body">
            <br><h5 class="text-center">{{ 'register.redirecting' | translate }}</h5>
            <div>
                <h1 class="text-center" style="font-size: 50px;">{{ timeLeft }}</h1>
            </div>
            <p>{{ 'register.active_url' | translate }}</p>
            <span class="input-group-addon activeURL">{{ subdomain }}</span>
            <p class="text-muted pt-2" style="font-size: 12px;">{{ 'register.to_bookmark' | translate }}</p>
            <hr class="divider">
            <p class="text-center">{{ 'register.info_sended_to' | translate }}</p>
            <p class="text-center red">{{ registeredEmail }}</p>
        </div>
    </div>
</div>

